module.exports = __webpack_public_path__ + "static/media/atendimento-3.5c223976.png";